import { defineStore, acceptHMRUpdate } from "pinia"
import * as XLSX from "xlsx"
// import type { Toast } from "@nuxt/ui"

const URL_GET_TABLE = "select-grid"
const URL_INSERT = "insert"
const URL_UPDATE = "update"

type AppStore = {
    appId: string
    apiBaseUrl: string
    headerHeight: number
    tableData: TableItem[]

    // toast: Toast | undefined
}

export const useMainStore = defineStore("mainStore", {
    state: (): AppStore => ({
        appId: "evidence-okrskaru-mp-hmp",
        apiBaseUrl: useRuntimeConfig().public.backendUrl || "",
        headerHeight: 0,
        tableData: [],
    }),
    actions: {
        async fetchTable() {
            const loginStore = useLoginStore()
            try {
                const data = await $fetch<TableItem[]>(URL_GET_TABLE, {
                    baseURL: this.apiBaseUrl,
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + loginStore.keycloak?.token,
                    },
                })
                this.tableData = data
                console.log("Table data:", this.tableData)
            } catch (error) {
                console.log("Error fetching Table data", error)
            }
        },
        async insertSubmit(data: {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            [k: string]: any
        }): Promise<BackendResponse> {
            const loginStore = useLoginStore()
            try {
                const response = await $fetch<BackendResponse>(URL_INSERT, {
                    baseURL: this.apiBaseUrl,
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + loginStore.keycloak?.token,
                    },
                    body: JSON.stringify(data),
                })
                console.log(response)
                if (response.success) {
                    await this.fetchTable()
                }
                return response
            } catch (error) {
                console.log("Error inserting data", error)
                return {
                    message: JSON.stringify(error),
                    success: false,
                }
            }
        },
        async updateSubmit(data: {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            [k: string]: any
        }): Promise<BackendResponse> {
            const loginStore = useLoginStore()
            try {
                const response = await $fetch<BackendResponse>(URL_UPDATE, {
                    baseURL: this.apiBaseUrl,
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + loginStore.keycloak?.token,
                    },
                    body: JSON.stringify(data),
                })
                console.log(response)
                if (response.success) {
                    await this.fetchTable()
                }
                return response
            } catch (error) {
                console.log("Error updating data", error)
                return {
                    message: JSON.stringify(error),
                    success: false,
                }
            }
        },
        async exportData() {
            const data = this.tableData
            const ws = XLSX.utils.json_to_sheet(data)
            const wb = XLSX.utils.book_new()
            XLSX.utils.book_append_sheet(wb, ws, "Data")
            XLSX.writeFile(wb, `${this.appId}.xlsx`)
        },
    },
})

type MetaHot = ImportMeta & {
    hot?: {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        accept: (fn: (module: any) => void) => void
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        dispose: (fn: (data: any) => void) => void
    }
}

if ((import.meta as MetaHot).hot) {
    ;(import.meta as MetaHot).hot?.accept(
        acceptHMRUpdate(useMainStore, (import.meta as MetaHot).hot)
    )
}
